import { render, staticRenderFns } from "./ApprovalPageB2.vue?vue&type=template&id=5499610e"
import script from "./ApprovalPageB2.vue?vue&type=script&lang=js"
export * from "./ApprovalPageB2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports